export const column = ['0 0 32 32',`
<path d="M0 0.342h7.094v31.317h-7.094v-31.317z"></path>
<path d="M12.453 0.342h7.094v31.317h-7.094v-31.317z"></path>
<path d="M24.906 0.342h7.094v31.317h-7.094v-31.317z"></path>
`]
